import { store } from '@/store';
import isGiftCardsEnabled from '@/utils/gift-card-utils';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';

/**
 * Reject gift card access for employees and disabled E-Gift card configuration
 * And allow for other cases
 * @param {*} to destination
 * @param {*} from source
 * @param {*} next next route
 */
export default async function giftCardAccess(to, from, next) {
  const isEmployee = store.getters['user/isEmployee'];
  const isCustomer = store.getters['user/isCustomer'];
  const giftCardsConfigured = store.getters.getConfiguration.allowEGiftCards;
  const orderTypesEnabled = store.getters.getConfiguration.orderTypesEnabled;
  const orderTypes = store.getters.getConfiguration.orderTypes;
  const allowEGiftCards = isGiftCardsEnabled(giftCardsConfigured, orderTypesEnabled, orderTypes);

  /* Check if logged in user is only employee (not associated with any customer),
   * then restrict access, else redirect
   */
  if (isEmployee && !isCustomer) {
    next({ name: 'EmployeeCustomerSelect' });
    ToastService.open(WCSimpleToast, {
      props: {
        variant: 'warning',
        title: 'Authentication',
        message: 'Associate as customer to access the page',
      },
      timeout: 7000,
    });
  } else if (!allowEGiftCards) {
    next({ name: 'NotFound' });
  } else {
    next();
  }
}
